export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-04.b9a81f52.jpg";